/**
 * Nomi delle capability, allineati a IncassiPermissions lato backend.
 * Sono l'unico punto in cui queste stringhe compaiono: scritte inline nei
 * componenti, un refuso non darebbe errore di compilazione e — con il default
 * a negato — nasconderebbe un comando in silenzio.
 *
 * Convenzione: {Modulo}.{Oggetto}.{Azione}
 */
export const CapabilityNames = {
  incassoCrea: 'Incassi.Incasso.Crea',
  incassoModifica: 'Incassi.Incasso.Modifica',
  incassoElimina: 'Incassi.Incasso.Elimina',
  incassoEliminaConfermato: 'Incassi.Incasso.EliminaConfermato',

  brogliaccioCrea: 'Incassi.Brogliaccio.Crea',
  brogliaccioConferma: 'Incassi.Brogliaccio.Conferma',
  brogliaccioElimina: 'Incassi.Brogliaccio.Elimina',

  distintaCrea: 'Incassi.Distinta.Crea',
  distintaVerifica: 'Incassi.Distinta.Verifica',
  distintaChiudi: 'Incassi.Distinta.Chiudi',
  distintaElimina: 'Incassi.Distinta.Elimina',
} as const;

export type CapabilityName = (typeof CapabilityNames)[keyof typeof CapabilityNames];
